import { useEffect } from 'react';
import { login } from '../services/auth.service';
import { useAuth } from '../hooks/useAuth';
import { useNavigate } from 'react-router-dom';

export const Login = () => {
    // only login if the user is not already logged in.
    const user = useAuth();
    const navigate = useNavigate();
    useEffect(() => {
        if (!user) {
            login();
        } else {
            navigate('/'); // go home
        }
    }, [user]);

    return null;
};
